/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/MoreEpisodes/theme';

export const MoreEpisodesTheme = theme;
